<div class="services-cannot-shop-container">
  <form #servicesCannotShopForm="ngForm" class="services-cannot-shop-form">
    <div class="section-header mb-3">
      <h5>Required Services You CANNOT Shop For</h5>
    </div>

    <div class="row">
      <div class="col-md-6 mb-3">
        <label class="form-label">Appraisal Fee</label>
        <currency-input
          [(ngModel)]="formData.appraisalFee"
          name="appraisalFee"
          [allowEmpty]="true"
          [readonly]="true">
        </currency-input>
      </div>
      <div class="col-md-6 mb-3">
        <label class="form-label">Credit Report</label>
        <currency-input
          [(ngModel)]="formData.creditReport"
          name="creditReport"
          [allowEmpty]="true"
          [readonly]="false">
        </currency-input>
      </div>
    </div>

    <!-- Dynamic Fees Section -->
    <div class="dynamic-fees-section mt-4">
      <div class="section-header mb-3">
        <h6>Additional Services You CANNOT Shop For</h6>
      </div>
      @if (formData.dynamicFees.length > 0) {
        <div class="row mb-2">
          <div class="col-md-6"><strong>Fee Name</strong></div>
          <div class="col-md-5"><strong>Amount ($)</strong></div>
          <div class="col-md-1"></div>
        </div>
      }

      @for (fee of formData.dynamicFees; track fee.uuid; let i = $index) {
        <div class="row mb-2">
          <div class="col-md-6">
            <input type="text" class="form-control" [(ngModel)]="fee.name"
                   [name]="'dynamicFeeName_' + i"
                   placeholder="Fee name">
          </div>
          <div class="col-md-5">
            <currency-input [(ngModel)]="fee.amount" [name]="'dynamicFeeAmount_' + i"
                            [allowEmpty]="true">
            </currency-input>
          </div>
          <div class="col-md-1">
            <button type="button" class="btn btn-sm btn-danger"
                    (click)="removeDynamicFee(i)">
              <i class="pi pi-trash"></i>
            </button>
          </div>
        </div>
      }

      <button type="button" class="btn btn-sm btn-primary mt-2"
              (click)="addDynamicFee()">
        <i class="pi pi-plus"></i> Add Fee
      </button>
    </div>
  </form>
</div>
